module.exports = __webpack_public_path__ + "img/hand-holding-seedling.53993ae8.png";